module.exports = __webpack_public_path__ + "static/media/liyushan_package.2888acea.webp";